import React, { FC } from 'react';
import { breakpointMatches } from 'app/functions/grid';
import * as styles from './DayPickerNav.scss';
import { Button } from '@flixbus/honeycomb-react';
import { Icon, IconArrowLeft, IconArrowRight } from 'app/icons';
import { useTranslations } from 'app/hooks/useTranslations';
import { a11yLabelsKeys } from 'app/providers/a11yLabels';

type DayPickerNav = {
  showPreviousButton: boolean;
  onPreviousClick: () => void;
  onNextClick: () => void;
  children: React.ReactNode;
};

export const DayPickerNav: FC<DayPickerNav> = ({
  showPreviousButton,
  onPreviousClick,
  onNextClick,
  children,
}) => {
  const { getNextLabel, getPrevLabel } = useTranslations({
    getNextLabel: a11yLabelsKeys.dates.rightArrow,
    getPrevLabel: a11yLabelsKeys.dates.leftArrow,
  });

  return (
    <div className={styles.customizedNavBar}>
      <Button
        extraClasses={styles.button}
        onClick={onPreviousClick}
        disabled={!showPreviousButton || breakpointMatches('small').matches}
        display="square"
        aria-label={getPrevLabel()}
      >
        <Icon InlineIcon={IconArrowLeft} size={8} appearance="primary" />
      </Button>

      {children}

      <Button
        extraClasses={styles.button}
        onClick={onNextClick}
        disabled={breakpointMatches('small').matches}
        display="square"
        aria-label={getNextLabel()}
      >
        <Icon InlineIcon={IconArrowRight} size={8} appearance="primary" />
      </Button>
    </div>
  );
};
